'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchData = exports.dataFailure = exports.dataSuccess = exports.dataRequest = exports.MASON_DATA_FAILURE = exports.MASON_DATA_SUCCESS = exports.MASON_DATA_REQUEST = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = withMapperData;

var _react = require('react');

var _reactRedux = require('react-redux');

var _reduxActions = require('redux-actions');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _api = require('../../middleware/api');

var _http = require('../../utils/http');

var _http2 = _interopRequireDefault(_http);

var _events = require('../../utils/events');

var _object = require('../../utils/object');

var _tree = require('../../utils/tree');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MASON_DATA_REQUEST = exports.MASON_DATA_REQUEST = 'MASON_DATA_REQUEST';
var MASON_DATA_SUCCESS = exports.MASON_DATA_SUCCESS = 'MASON_DATA_SUCCESS';
var MASON_DATA_FAILURE = exports.MASON_DATA_FAILURE = 'MASON_DATA_FAILURE';
var dataRequest = exports.dataRequest = (0, _reduxActions.createAction)(MASON_DATA_REQUEST);
var dataSuccess = exports.dataSuccess = (0, _reduxActions.createAction)(MASON_DATA_SUCCESS);
var dataFailure = exports.dataFailure = (0, _reduxActions.createAction)(MASON_DATA_FAILURE);

var mutableDatasource = function mutableDatasource(datasource) {
  return _lodash2.default.pick(datasource, 'headers', 'queries', 'name', 'url', 'verb');
};

function _fetchData(ownDatasource, datasourceId, componentId, options) {
  var d = _extends({}, ownDatasource, {
    headers: (0, _object.keyValueArrayToObject)(ownDatasource.headers),
    queries: (0, _object.keyValueArrayToObject)(ownDatasource.queries)
  });

  (0, _events.emitComponentEvent)(componentId, 'mason.willFetchData', d);

  var datasource = _extends({}, d, _lodash2.default.get(options, 'callbacks.before', _lodash2.default.identity)(mutableDatasource(d), componentId));

  return _defineProperty({}, _api.CALL_API, {
    endpoint: datasource.url,
    data: datasource.queries,
    headers: datasource.headers,
    lifecycleActions: [dataRequest, function (data) {
      return dataSuccess({
        componentId: componentId,
        data: _lodash2.default.get(options, 'callbacks.after', _lodash2.default.identity)(data, mutableDatasource(datasource), componentId),
        datasourceId: datasourceId,
        merge: _lodash2.default.get(options, 'merge', false)
      });
    }, function (data) {
      (0, _events.emitComponentEvent)(componentId, 'mason.error', data);
      return dataFailure({
        componentId: componentId,
        data: data,
        datasourceId: datasourceId
      });
    }],
    verb: datasource.verb || _http2.default.GET
  });
}

exports.fetchData = _fetchData;

function withMapperData(WrappedComponent) {
  var WithMapperData = function (_Component) {
    _inherits(WithMapperData, _Component);

    function WithMapperData(props) {
      _classCallCheck(this, WithMapperData);

      var _this = _possibleConstructorReturn(this, (WithMapperData.__proto__ || Object.getPrototypeOf(WithMapperData)).call(this, props));

      _this.configWithData = _this.configWithData.bind(_this);
      _this.paginator = _this.paginator.bind(_this);
      props.fetchData({
        callbacks: {
          before: props.willFetchData,
          after: props.didFetchData
        }
      });
      _this.state = {
        config: _this.configWithData(props.config)
      };
      return _this;
    }

    _createClass(WithMapperData, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (_lodash2.default.get(nextProps.config, 'id') !== _lodash2.default.get(this.props.config, 'id')) {
          nextProps.fetchData({
            callbacks: {
              before: nextProps.willFetchData,
              after: nextProps.didFetchData
            }
          });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (!_lodash2.default.isEqual(prevProps.data, this.props.data)) {
          this.setState({
            config: this.configWithData()
          });
        }
      }
    }, {
      key: 'configWithData',
      value: function configWithData() {
        var _this2 = this;

        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.config;

        if (_lodash2.default.isEmpty(this.props.data) || _lodash2.default.isEmpty(config)) {
          return config;
        }

        return (0, _immutabilityHelper2.default)(config, {
          data: {
            $set: _lodash2.default.reduce(config.data, function (result, subConfig, configKey) {
              return _extends({}, result, _defineProperty({}, configKey, _extends({}, subConfig, {
                tree: (0, _tree.repeat)(subConfig.tree, _this2.props.data, _this2.paginator)
              })));
            }, {})
          }
        });
      }
    }, {
      key: 'paginator',
      value: function paginator(datasourceId) {
        var _this3 = this;

        var datasource = _lodash2.default.get(this.props.datasources, datasourceId);

        var hasNext = datasource && (_lodash2.default.has(datasource.data, 'paging.next') || _lodash2.default.has(datasource.data, 'links.next'));

        if (hasNext) {
          var next = _lodash2.default.get(datasource.data.paging, 'next', false) || _lodash2.default.get(datasource.data.links, 'next');

          var headers = _lodash2.default.get(datasource, 'headers', []);

          var queries = []; // paging urls are assumed complete

          var options = {
            callbacks: {
              before: this.props.willFetchData,
              after: this.props.didFetchData
            },
            merge: true
          };
          return function (datasourceId) {
            return _this3.props.fetchDatasource({
              headers: headers,
              queries: queries,
              url: next
            }, datasourceId, options);
          };
        }

        return undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        return (0, _reactHyperscript2.default)(WrappedComponent, _extends({}, this.props, {
          config: this.state.config,
          updateDatasource: function updateDatasource(datasourceId, data, action, path) {
            return _this4.props.updateDatasources([{
              action: action,
              componentId: _this4.props.config.componentId,
              datasourceId: datasourceId,
              data: _this4.props.didFetchData(data, mutableDatasource(_lodash2.default.get(_this4.props.datasources, datasourceId, {})), _this4.props.config.componentId),
              path: path
            }]);
          },
          updateDatasources: function updateDatasources(ops) {
            return _this4.props.updateDatasources(_lodash2.default.map(ops, function (op) {
              return _extends({}, op, {
                componentId: _this4.props.config.componentId,
                data: _this4.props.didFetchData(op.data, mutableDatasource(_lodash2.default.get(_this4.props.datasources, op.datasourceId, {})), _this4.props.config.componentId)
              });
            }));
          }
        }));
      }
    }]);

    return WithMapperData;
  }(_react.Component);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    if (_lodash2.default.isEmpty(ownProps.config)) {
      return {};
    }

    return {
      data: _lodash2.default.mapValues(ownProps.datasources, function (datasource) {
        return datasource.data;
      }),
      didFetchData: function didFetchData(ownData, datasource, componentId) {
        var data = ownData;

        var didFetchData = _lodash2.default.get(ownProps, 'didFetchData', _lodash2.default.get(state.mason.callbacks, ownProps.id + '.didFetchData'));

        if (_lodash2.default.isFunction(didFetchData)) {
          data = didFetchData(data, datasource, componentId);
        }

        if (_lodash2.default.isFunction(state.mason.callbacks.didFetchData)) {
          data = state.mason.callbacks.didFetchData(data, datasource, componentId);
        }

        return data;
      },
      willFetchData: function willFetchData(ownDatasource, componentId) {
        var datasource = ownDatasource;

        var willFetchData = _lodash2.default.get(ownProps, 'willFetchData', _lodash2.default.get(state.mason.callbacks, ownProps.id + '.willFetchData'));

        if (_lodash2.default.isFunction(willFetchData)) {
          datasource = willFetchData(datasource, componentId);
        }

        if (_lodash2.default.isFunction(state.mason.callbacks.willFetchData)) {
          datasource = state.mason.callbacks.willFetchData(datasource, componentId);
        }

        return datasource;
      }
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
      fetchData: function fetchData(options) {
        if (_lodash2.default.isEmpty(ownProps.config)) {
          return;
        }

        var componentId = ownProps.config.componentId;
        var datasources = ownProps.config.data.default.datasources; // datasources in the config are just ids, full datasource is stored in project

        _lodash2.default.forEach(datasources, function (_ref2) {
          var id = _ref2.id;

          var datasource = _lodash2.default.get(ownProps.datasources, id);

          if (datasource && !datasource.fetchedAt) {
            // this is a check to avoid repeatedly refetching a datasource if component gets remounted
            dispatch(_fetchData(datasource, id, componentId, options));
          }
        });
      },
      fetchDatasource: function fetchDatasource(datasource, datasourceId, options) {
        if (_lodash2.default.isEmpty(ownProps.config)) {
          return;
        }

        var componentId = ownProps.config.componentId;
        dispatch(_fetchData(datasource, datasourceId, componentId, options));
      },
      updateDatasources: function updateDatasources(ops) {
        return dispatch(dataSuccess(ops));
      }
    };
  };

  WithMapperData.propTypes = {
    config: _propTypes2.default.shape({
      componentId: _propTypes2.default.string.isRequired,
      data: _propTypes2.default.object,
      id: _propTypes2.default.string.isRequired
    }),
    data: _propTypes2.default.object,
    // eslint-disable-line react/forbid-prop-types
    datasources: _propTypes2.default.object,
    // eslint-disable-line react/forbid-prop-types
    didFetchData: _propTypes2.default.func,
    fetchData: _propTypes2.default.func.isRequired,
    fetchDatasource: _propTypes2.default.func.isRequired,
    updateDatasources: _propTypes2.default.func.isRequired,
    willFetchData: _propTypes2.default.func
  };
  WithMapperData.defaultProps = {
    config: {},
    data: null,
    datasources: {},
    didFetchData: _lodash2.default.identity,
    willFetchData: _lodash2.default.identity
  };
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WithMapperData);
}